'use client';

import { NextIntlClientProvider } from 'next-intl';
import { useLanguage } from '@/lib/platform/contexts/language-context';
import { ReactNode } from 'react';

export default function IntlProvider({ children }: { children: ReactNode }) {
  const { locale } = useLanguage();

  // Dynamically import messages based on locale
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const messages = require(`@/messages/${locale}.json`);

  return (
    <NextIntlClientProvider locale={locale} messages={messages}>
      {children}
    </NextIntlClientProvider>
  );
}
